module.exports = __webpack_public_path__ + "assets/GTAmerica-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Bold.ttf
// module id = 995
// module chunks = 19